module.exports = __webpack_public_path__ + "static/img/104131.9ce6c514.png";